import { render, staticRenderFns } from "./uploadPhoto.vue?vue&type=template&id=adecba04&scoped=true&"
import script from "./uploadPhoto.vue?vue&type=script&lang=js&"
export * from "./uploadPhoto.vue?vue&type=script&lang=js&"
import style0 from "./uploadPhoto.vue?vue&type=style&index=0&id=adecba04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adecba04",
  null
  
)

export default component.exports